import { render } from "./AlertInfo.vue?vue&type=template&id=6d09b3e1&scoped=true"
import script from "./AlertInfo.vue?vue&type=script&lang=js"
export * from "./AlertInfo.vue?vue&type=script&lang=js"

import "./AlertInfo.vue?vue&type=style&index=0&id=6d09b3e1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d09b3e1"]])

export default __exports__